
import db from "../firebase";
import {setCategories, setLoadPage} from "../features/movie/movieSlice";
import {getDocs, collection} from "firebase/firestore"
const base_url = "https://api.themoviedb.org/3"
const api_key = "api_key=0aae5ee47b57c200a050d5506938c8e7" //make this private before u push to github!
const type = ''; //movie or tv ?
const id = '' // id number of the movie from movie db
const category = '' //the name of the collection in which to add the document in

//fetches the movie details from  movie db
const fetchMovies =  async (path, queryString, page) => {
    const endpoint_url = base_url+path+api_key+queryString+page;
    const response = await fetch(endpoint_url);
    const {results} = await response.json();
    return results;
}

//add a series to the firestore db
const addSeriesToDb = async(path, queryString, category) => {
    const endpoint_url = base_url+path+api_key+queryString
    const response = await fetch(endpoint_url);
    console.log(response)
    const {
        backdrop_path,
        poster_path,
        overview,
        genres,
        first_air_date,
        number_of_seasons,
        languages,
        id,
        name,
        videos,
        vote_average,
    } = await response.json();
    var trailer = null;
    const {results} = videos
    if(Object.keys(results).length !=0) {
        console.log(results)
        //const movie = results[0];
        const trailerList = results.filter((result) => result.type === "Trailer")
        //const checkTrailer = movie['name'];
        if (trailerList) {
            trailer = `https://www.youtube.com/embed/${trailerList[0]}`
        }
        else {
            trailer = null
           
        }
    }
    else {
        trailer = null;
        
    
    }
    const genreList = genres.map(({name}) => {
        return name
    })

    const languagesTotal = languages.length;
    const date = first_air_date.split("-");
    const year = date[0];
    const ratings = Math.round(vote_average*10);

    //series Modal
    const series = {
        backgroundImg: `https://image.tmdb.org/t/p/original${backdrop_path}`,
        cardImg: `https://image.tmdb.org/t/p/original${poster_path}`,
        description: {overview},
        genre: genreList,
        info: {
            age: null,
            company: null,
            duration: `${number_of_seasons} seasons`,
            languages: `${languagesTotal} langauges`,
            year,
        },
        movie_id: id.toString(),
        movie_tv: 'tv',
        title: name,
        ratings: ratings.toString(),
        trailer,
    }
    //adding document to movies collection
     db.collection(category).add(series);
}

//add a movie to the cloud firebase db
const addMovieToDb = async(path, queryString, category) => {
    const endpoint_url = base_url+path+api_key+queryString
    const response = await fetch(endpoint_url);
    const {
        backdrop_path,
        poster_path,
        overview,
        genres,
        release_date,
        runtime,
        spoken_languages,
        id,
        title,
        videos,
        vote_average,
    } = await response.json();
    var trailer = null;
    const {results} = videos
    if(Object.keys(results).length !=0) {
        //const movie = results[0];
        const trailerList = results.filter((result) => result.type === "Trailer")
        //const checkTrailer = movie['name'];
        if (trailerList) {
            trailer = `https://www.youtube.com/embed/${trailerList[0]}`
        }
        else {
            trailer = null
           
        }
    }
    else {
        trailer = null;
        
    
    }
    const genreList = genres.map(({name}) => {
        return name
    })

    const languagesTotal = spoken_languages.length;
    const date = release_date.split("-");
    const year = date[0];
    const ratings = Math.round(vote_average*10);
    function timeConvert(runtime){
        var num = runtime;
        var hours = (num/60);
        var rhours = Math.floor(hours);
        var minutes = (hours - rhours) *60;
        var rminutes = Math.round(minutes);
        return rhours + "h " + rminutes + "m";
    }
    const duration = timeConvert(runtime);

    //movie modal
    const movie = {
        backgroundImg: `https://image.tmdb.org/t/p/original${backdrop_path}`,
        cardImg: `https://image.tmdb.org/t/p/original${poster_path}`,
        description: {overview},
        genre: genreList,
        info: {
            age: null,
            company: null,
            duration,
            languages: `${languagesTotal} languages`,
            year,
        },
        movie_id: id.toString(),
        movie_tv: 'movie',
        title,
        ratings: ratings.toString(),
        trailer,
    }
    //adding document to movies collection
     db.collection(category).add(movie);
}

//function to post data to our data base
const postData = (type, id, category) => {
    switch (type) {
        case 'tv':
            addSeriesToDb(`/${type}/${id}?`, '&append_to_response=videos&language=en-US', category)
        break;
    
        case 'movie':
            addMovieToDb(`/${type}/${id}?`, '&append_to_response=videos&language=en-US', category)

    }
}

//function to update field in our dataBase. I wanted to add a trailer field.
const updateData = async(category) => {
    const collectionRef = db.collection(category);
    const snapshot = await collectionRef.get();
    await Promise.all(snapshot.docs.map(async (doc) => {
    //     const path = `/${doc.data().movie_tv}/${doc.data().movie_id}?`
    //     const queryString = `&append_to_response=videos&language=en-US`
    //     const endpoint_url = base_url+path+api_key+queryString;
    //     const response = await fetch(endpoint_url);
    //     const data = await response.json();
    //     var trailer = null;
    // const {results} = data["videos"]
    // if(Object.keys(results).length !=0) {
    //     //const movie = results[0];
    //     const trailerList = results.filter((result) => result.type === "Trailer")
    //     //const checkTrailer = movie['name'];
    //     if (trailerList) {
    //         trailer = `https://www.youtube.com/embed/${trailerList[0].key}`
    //     }
    //     else {
    //         trailer = null
           
    //     }
    // }
    // else {
    //     trailer = null;
        
    
    // }
    //     doc.ref.update({
    //         trailer,
    //     })
        
    const titleLowerCase = doc.data().title.toLowerCase();
    doc.ref.update({
        searchTerm: titleLowerCase
    })
    }))
 
}
const getCategories = async (categoriesTitles, dispatch) => {
            const categoriesList = [];
            await Promise.all(categoriesTitles.map(async(title) => {
            const movies = [];
            const querySnapshot = await getDocs(collection(db, title))
            querySnapshot.forEach((doc) => {
                const movieDetails = {id: doc.id, movieDetails: doc.data()}
                movies.push(movieDetails)
            })
            categoriesList.push({
                title,
                movies,
            })
        }))
        dispatch(setCategories({
            categoriesList,
        }))
        dispatch(setLoadPage({
            loadPage: false
        }))
        }

//updateData("hero carousel")
//postData(type, id, category)

  export  {fetchMovies, getCategories};